export default "__VITE_ASSET__DCTK1iVV__"